
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tnpsc/pre-structure",
      function () {
        return require("private-next-pages/tnpsc/pre-structure.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tnpsc/pre-structure"])
      });
    }
  